export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-italic-a9a7cfe6f4d906e26c1c1d0e4d31e4a4.eot";